import { useEffect, useState } from 'react';
import { api } from './utils';
import { getTenant, getUserName } from './helpers';

const useInstitutionMenu = (
  isUpdate,
  educationData,
  setEducationData,
  setIsLoading
) => {
  const [institutions, setInstitutions] = useState([]);

  const reorderInstitutions = (data, institutionId) => {
    const institutionIndex = data.findIndex(
      (institution) => institution.id === institutionId
    );
    if (institutionIndex !== -1) {
      return [
        data[institutionIndex],
        ...data.slice(0, institutionIndex),
        ...data.slice(institutionIndex + 1),
      ];
    }
    return data;
  };

  useEffect(() => {
    setIsLoading(true);
    api.ibldmcareer.getInstitution(
      { org: getTenant(), username: getUserName() },
      (data) => {
        setIsLoading(false);

        const updatedInstitutions = isUpdate
          ? reorderInstitutions(data, educationData.institution_id)
          : data;

        setInstitutions(updatedInstitutions);

        // Update the positionData with the first institution ID
        setEducationData((prevState) => ({
          ...prevState,
          institution_id:
            updatedInstitutions.length > 0 ? updatedInstitutions[0].id : 0,
        }));
      },
      (error) => {
        setInstitutions([]);
        setIsLoading(false);
      }
    );
  }, []);

  return { institutions, setInstitutions };
};

export { useInstitutionMenu };
